import { MutationTree } from 'vuex';
import { AddressBooksState } from './types';

export const mutations: MutationTree<AddressBooksState> = {
    setAddressBooks:(state, data) => {
        state.addressBooks = data
    },
    setAddressBookItem:(state, data) => {
        state.addressBookItem = data
    },
    setAddressBookContacts:(state, data) => {
        state.addressBookContacts = data
    },
    setAddressBookContactsMore:(state, data) => {
        state.addressBookContacts = state.addressBookContacts.concat(data)
    },
    setAddressBookContactItem:(state, data) => {
        state.addressBookContactItem = data
    },
};
